import { Grid, Typography } from '@mui/material';
import VerticalStepperComponent, {
  VerticalStepperStep,
} from '../../../../../components/verticalStepper/verticalStepper.component';
import { FC } from 'react';
import { useTranslation } from '../../../../../../hooks/useTranslationHook';

type StudentAdmissionViewProps = {
  admissionSteps: VerticalStepperStep[];
  onCompleteHandler: () => void;
  editMode: boolean;
};

const StudentAdmissionView: FC<StudentAdmissionViewProps> = ({
  admissionSteps,
  onCompleteHandler,
  editMode,
}) => {
  const { translateText } = useTranslation();
  return (
    <Grid
      container
      spacing={{ xs: 1, sm: 2 }}
      sx={{ 
        pb: { xs: 2, sm: 4 }, 
        height: '100%',
        px: { xs: 1, sm: 2 },
      }}
      id="admission-steps-container"
      data-testid="student-admission-view-container"
    >
      <Grid
        item
        xs={12}
        sx={{ 
          height: { xs: 'auto', sm: '60px' }, 
          display: 'flex', 
          alignItems: 'center',
          mb: { xs: 1, sm: 0 },
        }}
        data-testid="admission-steps-header"
      >
        <Typography 
          variant="body2"
          sx={{
            fontSize: { xs: '0.875rem', sm: '1rem' },
          }}
        >
          {translateText('students.admission.fourStepsToComplete')}
        </Typography>
      </Grid>
      <Grid
        item
        xs={12}
        sx={{ height: { xs: 'auto', sm: 'calc(100% - 60px)' } }}
        data-testid="admission-steps-container"
      >
        <VerticalStepperComponent
          steps={admissionSteps}
          keepStepsMounted
          finishButtonLabel={translateText(
            'students.admission.completeAdmission'
          )}
          onCompleteHandler={onCompleteHandler}
          onCompleteMessage={
            editMode
              ? translateText('students.admission.updateCompleteMessage')
              : translateText('students.admission.addCompleteMessage')
          }
        />
      </Grid>
    </Grid>
  );
};

export default StudentAdmissionView;
